import { ProfileInformationScreen } from "@/interactors/ProfileInformationScreen";

export default function ProfileInformation() {
  return <ProfileInformationScreen />;
}
